import { QuantityField } from '@flos/react-ui';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import { useHippoText } from '../../../../hooks/useHippoText';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { type CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import { useState } from 'react';
import { track } from '../../../../utils/trackingUtil';
import HelpLink from '../../../../shared_components/HelpLink/HelpLink';
import { getAgeOfTheOldestFromCoverableList } from '../../../../utils/coverablesUtil';

const ContentNumberInHouseholdStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [coverables, setCoverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const contentCoverables = coverables.privateContent ?? [];
    const coverableIndex = contentCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentContentCoverable = contentCoverables[coverableIndex];

    const handleNumberInHousehold = (value: number): void => {
        const updatedCoverables = [...contentCoverables];

        updatedCoverables[coverableIndex] = {
            ...updatedCoverables[coverableIndex],
            numberInHousehold: value
        };

        setCoverables((prev) => ({
            ...prev,
            privateContent: updatedCoverables
        }));
    };

    const onNext = (): void => {
        setIsLoading(true);
        const existingAgeOfTheOldest = getAgeOfTheOldestFromCoverableList(coverables);

        const updatedCoverable: CoverableInformationToUpdateDTO = {
            privateContent: {
                publicId: currentContentCoverable.publicId,
                fixedId: currentContentCoverable.fixedId,
                numberInHousehold: currentContentCoverable.numberInHousehold,
                ageOfOldestInHousehold: existingAgeOfTheOldest
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            track(`${currentProduct.flavourName}CoverableInformationNumberOfPeopleInHousehold`, [
                {
                    numberInHousehold: currentContentCoverable.numberInHousehold,
                    ageOfOldestInHousehold: existingAgeOfTheOldest
                }
            ]);
            goNext();
            setIsLoading(false);
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            onPrevious={goPrevious}
            disableNext={isLoading || !currentContentCoverable.numberInHousehold}
            isNextLoading={isLoading}
            disablePrevious={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-NUMBER-OF-MEMBERS-HEADER')}
                subheader={getHippoText(
                    'DSS-COVERABLE-INFORMATION-STEP-NUMBER-OF-MEMBERS-SUBHEADER'
                )}
            >
                <div className="u-display-inline-block u-spacing-stack-none@xs u-spacing-stack-bottom-5">
                    <QuantityField
                        onChange={handleNumberInHousehold}
                        defaultValue={currentContentCoverable.numberInHousehold}
                    />
                </div>
                <HelpLink
                    onClick={() => {
                        setShowModal(true);
                    }}
                >
                    {getHippoText('DSS-COVERABLE-INFORMATION-STEP-PRC-ADDRESS-WHO-IS-COVERED')}
                </HelpLink>
            </CoverableDetailsTemplate>
            <ViewHippoInformationModal
                showModal={showModal}
                closeModal={() => {
                    setShowModal(false);
                }}
                modalProps={{
                    title: 'DSS-CON -HIGHLIGHTED-TEXT-MODAL-AMOUNT-OF-RESIDENTS-TITLE',
                    description:
                        currentProduct.flavourName === 'Indboforsikring'
                            ? 'DSS-CON -HIGHLIGHTED-TEXT-MODAL-AMOUNT-OF-RESIDENTS'
                            : 'DSS-CON -HIGHLIGHTED-TEXT-MODAL-AMOUNT-OF-RESIDENTS-YOUTH'
                }}
            />
        </WizardPagetemplate>
    );
};

export default ContentNumberInHouseholdStep;
